import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { projectList } from "constants/project";

export const getProjectList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.project_list(pageNum, filters);
    dispatch({ type: projectList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: projectList,
      payload: error?.response?.data || error,
    });
  }
};
